/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {DiplomatObject} from './DiplomatObject';
import {enums} from './enums';

export const LogFileSettings = DiplomatObject.shape({
   location: yup.string(),
   reportingLevel: yup.string().oneOf(enums.minimumLevel.keys),
   maxSize: yup.number().integer().min(1),
   maxAge: yup.number().integer().min(1),
   daysToKeep: yup.number().integer().min(1),
   performanceFrequency: yup.number().integer().min(0),
});
export type ILogFileSettings = yup.InferType<typeof LogFileSettings>;
